const getSrcSets = (widths, basicRoute, basicName) => {
  const getSources = (fileType) =>
    widths.map((width) => basicRoute + basicName + '_w' + width + fileType + ' ' + width + 'w');

  const webpSrcSet = getSources('.webp').join(', ');
  const jpgSrcSet = getSources('.jpg').join(', ');

  return {webpSrcSet, jpgSrcSet};
};

export {getSrcSets};
